import toastr from "toastr";

toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    positionClass: "toast-bottom-full-width",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut"
};

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".js-success-message").forEach((element) => {
        const msg = element.dataset.message;
        if (msg && msg.trim()) toastr.success(msg);
    });
    document.querySelectorAll(".js-error-message").forEach((element) => {
        const msg = element.dataset.message;
        if (msg && msg.trim()) toastr.error(msg);
    });
});
